<div
  class="fui-layout-header"
  [class.fui-hero-section]="!!heroImageUrl"
  [class.fui-hero-with-gradient]="!!heroImageUrl && includeGradient"
  [class.fui-hero-with-drift]="!!heroImageUrl && includeKenBurnsEffect"
  [class.theme_plainlight]="heroImageUrl && heroTheme === 'light'"
  [class.theme_plaindark]="heroImageUrl && heroTheme === 'dark'"
>
  @if (heroImageUrl) {
    <!--
      Hero media (2026-09-01, matching docs/communities-page-redesign.html). The image
      lives in its own `<img>` element (not `background-image`) so the Ken Burns "drift"
      animation can transform it independently of the container.
      The scrim gradient — fading the image into the page bg at the bottom — is rendered
      via `.fui-hero-section::after` in `_fender-ui.scss` so BOTH this new pattern AND
      the legacy wrapper-based pattern (community-detail) pick it up automatically.
    -->
    <div class="fui-hero-media" aria-hidden="true">
      <!-- Usually one image; two while one crossfades into the next (`heroLayers`). -->
      @for (layer of heroLayers; track layer.id) {
        <img [src]="layer.url" alt="" [class.is-shown]="layer.shown" (load)="onHeroLayerReady(layer)" (error)="onHeroLayerReady(layer)" />
      }
    </div>
  }
  <div class="fui-breadcrumbs m-b-50">
    <ul>
      @for (crumb of translatedBreadcrumbs; track crumb; let last = $last) {
        <li>
          @if (crumb.routerLink) {
            <a [routerLink]="crumb.routerLink">{{ crumb.label }}</a>
          }
          @if (crumb.clickHandler && !crumb.routerLink) {
            <a href="javascript:void(0);" (click)="crumb.clickHandler()">{{ crumb.label }}</a>
          }
          @if (!crumb.routerLink && !crumb.clickHandler) {
            <span [attr.aria-current]="last ? 'page' : null">{{ crumb.label }}</span>
          }
        </li>
        <!-- A separator, not a crumb: kept out of the list a screen reader counts. -->
        @if (!last) {
          <li aria-hidden="true">&bull;</li>
        }
      }
    </ul>
  </div>
  <div class="fui-layout-header-top">
    <div class="fui-layout-header-title-block">
      @if (loading) {
        <myp-skeleton-loader type="line" height="48px" width="60%" borderRadius="6px"></myp-skeleton-loader>
        @if (showDescription) {
          <myp-skeleton-loader type="line" height="14px" width="90%" extraContainerClass="m-t-20"></myp-skeleton-loader>
          <myp-skeleton-loader type="line" height="14px" width="70%" extraContainerClass="m-t-10"></myp-skeleton-loader>
        }
      } @else {
        <div class="fui-layout-header-heading-row">
          @if (showBackButton) {
            <button type="button" class="btn btn-transparent p-0 fui-layout-header-back" (click)="backClicked.emit()">
              <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
              <span class="sr-only">{{ "productDetail.back_sr_only" | translate }}</span>
            </button>
          }
          <fui-heading [text]="translatedHeadingText" level="1" fontSize="f11"></fui-heading>
        </div>
        @if (translatedDescription && showDescription) {
          <p class="m-t-20">{{ translatedDescription }}</p>
        }
      }
    </div>
    <div class="fui-layout-header-actions">
      <ng-content select="[fuiLayoutHeaderActions]"></ng-content>
    </div>
  </div>
  <ng-content></ng-content>
</div>
